<template>
  <v-card
    max-width="1250"
    class="pa-0 mx-auto"
    :disabled="loading"
    :loading="loading"
  >
    <v-toolbar color="primary">
      <v-toolbar-title
        ><h1>
          {{ $t("list.system") }}
        </h1>
      </v-toolbar-title>
    </v-toolbar>
    <h2 class="text-center pt-2">
      {{ $t("info.admityear") }} : {{ admitSemester }} / {{ admitYear }}
    </h2>
    <div class="text-center pt-1">
      <v-chip color="#ddd" variant="flat"
        ><v-card-text
          ><h3>
            {{ $t("info.undergraduate") }}
          </h3></v-card-text
        ></v-chip
      >
    </div>
    <h1 class="text-center pt-1 mb-3">
      {{ $t("list.prestudent_list") }}
    </h1>
    <v-card class="mx-0 mx-md-2 mb-md-2" :disabled="loading" :loading="loading">
      <v-card-text class="px-0 pb-0 custom-card">
        <v-window v-model="level_tab">
          <v-window-item
            v-for="(level, i) in levels"
            :value="level.LEVEL_ID"
            :key="i"
          >
            <div class="px-3">
              <h4 class="pb-1">{{ $t("list.faculty") }}</h4>
              <v-autocomplete
                density="compact"
                v-model="selected_facultyID"
                v-bind:items="facultys"
                v-bind:item-value="(item) => item.faculty_id"
                v-bind:item-title="
                  (item) =>
                    inlineTranslator({
                      th: item.faculty_name,
                      en: item.faculty_ename,
                    })
                "
                @update:modelValue="update_faculty"
                outlined
              ></v-autocomplete>

              <h4 class="pb-1">{{ $t("list.curriculum") }}</h4>
              <v-autocomplete
                density="compact"
                v-model="selected_currID"
                v-bind:items="curriculums"
                v-bind:item-value="(item) => item.curr_id"
                v-bind:item-title="
                  (item) =>
                    inlineTranslator({
                      th: item.curr_tname,
                      en: item.curr_ename,
                    })
                "
                @update:modelValue="getStudentList"
                :disabled="selected_facultyID === null ? true : false"
                outlined
              ></v-autocomplete>

              <h4 class="pb-1">{{ $t("list.search") }}</h4>
              <v-text-field
                v-model="keywords"
                clearable
                class="pa-0"
                variant="solo-filled"
                density="compact"
                :disabled="search_disable"
                append-inner-icon="mdi-magnify"
              ></v-text-field>
            </div>
            <div
              class="justify-content-center text-end"
              v-if="selected_currID !== null"
            >
              <v-btn
                class="mr-3"
                color="primary"
                @click="refresh()"
                variant="outlined"
              >
                <v-icon class="my-auto mr-2">mdi-table-refresh</v-icon>
                refresh
              </v-btn>
            </div>
            <v-table
              theme="KMITLTheme"
              class="mx-0 mx-md-3 mb-3"
              v-show="selected_currID !== null"
            >
              <thead>
                <tr>
                  <th class="text-center">#</th>
                  <th class="text-center">{{ $t("list.apply_number") }}</th>
                  <th class="text-center">{{ $t("list.student_id") }}</th>
                  <th class="text-center">{{ $t("list.name") }}</th>
                  <th class="text-center">{{ $t("list.surname") }}</th>
                  <th class="text-center">{{ $t("list.status") }}</th>
                  <th class="text-center"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="students.length == 0">
                  <td colspan="7">
                    <p class="text-center text-secondary">no result</p>
                  </td>
                </tr>
                <tr
                  v-for="(item, index) in students"
                  v-bind:key="item.APPLY_ID"
                >
                  <td class="text-center">{{ index + 1 }}</td>
                  <td class="text-center">{{ item.APPLY_ID }}</td>
                  <td class="text-center font-weight-bold gradient-text">
                    {{ item.STUDENT_ID }}
                  </td>
                  <td>
                    {{
                      inlineTranslator({
                        th: item.STUDENT_FNAME_TH,
                        en: item.STUDENT_FNAME_EN,
                      })
                    }}
                  </td>
                  <td>
                    {{
                      inlineTranslator({
                        th: item.STUDENT_LNAME_TH,
                        en: item.STUDENT_LNAME_EN,
                      })
                    }}
                  </td>
                  <td class="text-center">
                    <v-chip :color="item.TEXT_CLASS">
                      {{ objectTranslator(item, "MATRICULATION_STATUS_NAME") }}
                    </v-chip>
                    <p
                      v-if="
                        is_authorized_officer &&
                        (item.MATRICULATION_STATUS_ID == '1' ||
                          item.MATRICULATION_STATUS_ID == '2' ||
                          item.MATRICULATION_STATUS_ID == '3')
                      "
                    >
                      {{ dt(item.LAST_ACTION_TIMESTAMP) }}
                    </p>
                  </td>
                  <td class="text-center">
                    <v-btn
                      color="primary"
                      height="35"
                      variant="elevated"
                      size="small"
                      @click="goTo(item.UID)"
                      >Login
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </v-table>
          </v-window-item>
        </v-window>
      </v-card-text>
    </v-card>
  </v-card>
</template>

<script>
import {
  listFilter,
  uniq_by_prop,
  getById,
  includeString,
} from "@/helper/filter";
import {
  objectTranslator,
  inlineTranslator,
  dateTimeFromDBTranslatorFull as dt,
} from "@/helper/translator";
import RefProvider from "@/services/ref.provider";
import PublicProvider from "@/services/public.provider.js";

const publicProvider = new PublicProvider();
const refService = new RefProvider();
// @ is an alias to /src

export default {
  name: "ListUndergraduate",

  data: () => ({
    loading: false,

    level_tab: 1,
    keywords: "",

    selected_facultyID: null,
    selected_currID: null,

    yearId_level1: null,
    admitYear_level1: null,
    admitSemester_level1: null,

    yearId_level2: null,
    admitYear_level2: null,
    admitSemester_level2: null,

    curriculums_level1: [],
    curriculums_level2: [],

    all_status: [],

    // students: [],
    students_all: [],

    levels: [
      {
        LEVEL_ID: 1,
        LEVEL_NAME_EN: "Undergraduate",
        LEVEL_NAME_TH: "ปริญญาตรี",
      },
    ],
  }),

  methods: {
    getById,
    listFilter,
    objectTranslator,
    inlineTranslator,
    dt,

    async fetch_data() {
      this.loading = true;

      const y1 = await publicProvider.getCurrentYear(1).catch((error) => {
        this.$toast.error(JSON.stringify(error.response.data.message));
      });
      if (y1) {
        this.yearId_level1 = y1.YEAR_ID;
        this.admitYear_level1 = y1.ADMIT_YEAR;
        this.admitSemester_level1 = y1.ADMIT_SEMESTER;
      }

      const curr1 = await publicProvider
        .getRegistrarFacultyCurrPostGraduate()
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
        });
      this.curriculums_level1 = curr1;

      const status = await refService
        .getMatriculationStatus()
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
        });
      this.all_status = status;

      this.loading = false;
    },
    handleTabClick(tab) {
      this.$router.push({ path: "/list", query: { tab } });
      this.selected_facultyID = null;
      this.selected_currID = null;
      this.keywords = "";
      this.students_all = [];
    },
    update_faculty() {
      this.selected_currID = null;
      this.keywords = "";
      this.students_all = [];
    },
    async getStudentList() {
      this.loading = true;

      this.keywords = "";
      const data = await publicProvider
        .getStudentList(
          this.level_tab,
          this.selected_facultyID,
          this.selected_currID
        )
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
        });
      if (data) {
        data.map((item) => {
          if (item.MATRICULATION_STATUS_ID) {
            const ref_data = getById(
              this.all_status,
              item.MATRICULATION_STATUS_ID,
              "MATRICULATION_STATUS_ID"
            );
            item.MATRICULATION_STATUS_NAME_TH =
              ref_data.MATRICULATION_STATUS_NAME_TH;
            item.MATRICULATION_STATUS_NAME_EN =
              ref_data.MATRICULATION_STATUS_NAME_EN;
            item.TEXT_CLASS = ref_data.TEXT_CLASS;
          }
          if (item.STUDENT_FNAME_EN == "") {
            item.STUDENT_FNAME_EN = item.STUDENT_FNAME_TH;
            item.STUDENT_LNAME_EN = item.STUDENT_LNAME_TH;
          }
          return item;
        });
        this.students_all = data;
      }

      this.loading = false;
    },
    async refresh() {
      this.getStudentList();
    },

    async goTo(UID) {
      if (this.$store.state.user.is_authorized_officer == true) {
        this.loading = true;
        sessionStorage.setItem("surrogated_student_uid", UID);
        await this.$store.dispatch("user/getUserInfo");
        if (
          this.$store.state.user.surrogated_student_info
            .MATRICULATION_STATUS_ID !== "0"
        ) {
          let route = this.$router.resolve({ name: "main_officer" });
          window.open(route.href, "_blank");
        } else {
          this.$router.push({ path: "/main" });
        }
      } else {
        this.$router.push({ path: "/main" });
      }
      this.loading = false;
    },
  },

  computed: {
    is_authorized_officer() {
      return this.$store.state.user.is_authorized_officer;
    },

    yearId() {
      let data = null;
      if (this.level_tab == 1) {
        data = this.yearId_level1;
      } else {
        data = this.yearId_level2;
      }
      return data;
    },
    admitYear() {
      let data = null;
      if (this.level_tab == 1) {
        data = this.admitYear_level1;
      } else {
        data = this.admitYear_level2;
      }
      return data;
    },
    admitSemester() {
      let data = null;
      if (this.level_tab == 1) {
        data = this.admitSemester_level1;
      } else {
        data = this.admitSemester_level2;
      }
      return data;
    },
    facultys() {
      let data = null;
      if (this.level_tab == 1) {
        data = this.curriculums_level1;
      } else {
        data = this.curriculums_level2;
      }

      const uniqueById = uniq_by_prop("faculty_id");
      const ret = uniqueById(data);
      return ret.map((item) => ({
        faculty_id: item.faculty_id,
        faculty_name: item.faculty_name,
        faculty_ename: item.faculty_ename,
      }));
    },
    curriculums() {
      let data = [];
      if (this.selected_facultyID != null) {
        if (this.level_tab == 1) {
          data = this.curriculums_level1;
        } else {
          data = this.curriculums_level2;
        }
        data = listFilter(data, this.selected_facultyID, "faculty_id");
      }
      return data;
    },
    search_disable() {
      if (this.selected_facultyID && this.selected_currID) {
        return false;
      } else {
        return true;
      }
    },
    students() {
      let data = this.students_all;
      if (this.keywords && this.keywords.length !== 0) {
        data = data.filter((item) => {
          return (
            includeString(item.APPLY_ID, this.keywords) ||
            includeString(item.STUDENT_ID, this.keywords) ||
            includeString(item.STUDENT_FNAME_TH, this.keywords) ||
            includeString(item.STUDENT_LNAME_TH, this.keywords) ||
            includeString(item.STUDENT_FNAME_EN, this.keywords) ||
            includeString(item.STUDENT_LNAME_EN, this.keywords)
          );
        });
      }
      return data;
    },
  },

  created() {
    const tab = parseInt(this.$route.query.tab);
    if (tab) {
      this.level_tab = tab;
    }
    this.fetch_data();
  },
};
</script>

<style scoped>
.custom-card {
  border: 1px solid #dadada;
  border-radius: 0px;
}
.inline-h2 {
  color: black;
}
</style>
